import {} from 'vue';
import { registerPiniaStore } from '../config/pinia-store';
import { registerPrimeVue } from '../config/primevue';
import { createVue3AppPackage } from './base';
export async function configureApp(app) {
    await import('../styles/theme.css');
    registerPrimeVue(app);
    registerPiniaStore(app);
    return app;
}
export default createVue3AppPackage(async () => (await import('../views/oasis-layout.vue')).default, (app) => configureApp(app));
